import { apiWrapper } from "@/services/api";

export const getStationsForMFITT = async () => {
  let activeStations;
  try {
    const response = await apiWrapper("GET", `/mfitt/stations`);
    console.log("getStation response.data :>> ", response.data);
    // 利用できる駅はis_active:trueの駅のみなので、抽出する
    activeStations = response.data.filter((station) => station.is_active);
  } catch (err) {
    console.log('ERROR"" getStation():', err);
    throw err;
  }
  return activeStations;
};
